import { render, staticRenderFns } from "./CalculatorCrudoRegalias.vue?vue&type=template&id=158204ed"
import script from "./CalculatorCrudoRegalias.vue?vue&type=script&lang=js"
export * from "./CalculatorCrudoRegalias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports